// Shared socket instance across all useSocket usages in this app (and the logout flow).
export const socketRef = { current: null };

/** Closes the shared socket, if any. Returns true if one was open. */
export function closeSharedSocket() {
  if (!socketRef.current) return false;
  try {
    socketRef.current.close();
  } catch (_) {}
  socketRef.current = null;
  return true;
}
